export const CircuitoResoData = [
  {
    pregunta: "¿La orden médica indica con contraste o Gadolinio?",
    name: "contraste",
    valor: null,
    visible: true,
    input: false,
    subitem: false,
    key: 0,
  },
  {
    pregunta: `¿Tiene insuficiencia renal?`,
    name: "renal",
    valor: null,
    visible: false,
    input: false,
    subitem: false,
    key: 1,
  },
  {
    pregunta: `¿Realizó un laboratorio de Función Renal en los últimos 30 días?`,
    name: "labFuncionRenal",
    valor: null,
    visible: false,
    input: false,
    subitem: true,
    key: 2,
  },
  {
    pregunta: `¿Cuánto pesa?`,
    name: "peso",
    valor: null,
    visible: true,
    input: true,
    subitem: false,
    key: 3,
  },
  {
    pregunta: `¿Tiene Marcapasos?`,
    name: "marcaPasos",
    valor: null,
    visible: true,
    input: false,
    subitem: false,
    key: 4,
  },
  {
    pregunta: ``,
    name: "datosMarcaPasos",
    valor: "",
    visible: false,
    multiInput: true,
    subitem: true,
    key: 5,
  },
  {
    pregunta: `¿Tiene Implantes Metálicos?`,
    name: "implantesMetalicos",
    valor: null,
    visible: true,
    input: false,
    subitem: false,
    key: 6,
  },
  {
    pregunta: ``,
    name: "datosImplantes",
    valor: "",
    visible: false,
    multiInput: true,
    subitem: true,
    key: 7,
  },
  {
    pregunta: `¿Se realizó en las últimas 72 hs. algún estudio con contraste (resonancia, camara gamma, etc.)?`,
    name: "estudioPrevio",
    valor: null,
    visible: true,
    input: false,
    subitem: false,
    key: 8,
  },
  {
    pregunta: ``,
    name: "marcaMarcapasos",
    valor: null,
    visible: false,
    input: false,
    subitem: false,
    key: 9,
  },
  {
    pregunta: ``,
    name: "modeloMarcapasos",
    valor: null,
    visible: false,
    input: false,
    subitem: false,
    key: 10,
  },
  {
    pregunta: ``,
    name: "materialImpMet",
    valor: null,
    visible: false,
    input: false,
    subitem: false,
    key: 11,
  },
  {
    pregunta: ``,
    name: "ubicacionImpMet",
    valor: null,
    visible: false,
    input: false,
    subitem: false,
    key: 12,
  },
  {
    pregunta: ``,
    name: "fechaMarcapasos",
    valor: null,
    visible: false,
    input: false,
    subitem: false,
    key: 13,
  },
  {
    pregunta: ``,
    name: "fechaImpMet",
    valor: null,
    visible: false,
    input: false,
    subitem: false,
    key: 14,
  },
];
